import { put, takeEvery, select, delay } from "redux-saga/effects";
import SettingsAction from "../settings/settingsAction";
import CampaignAction from "./campaignAction";
import {mockCampaigns} from "../../mock/campaigns/campaigns";
import {apiAvatarsService, apiCampaignsService, apiEventsService} from "../../config/api";
import {
  transformCampaign, transformCampaignComments, transformCampaignLikes,
  transformCampaignList,
  transformCampaignPosts, transformCampaignWeeks,
  transformEventFilters, transformPostChildren
} from "./campaignTransformer";
import {
  selectCampaignEvents,
  selectCampaignEventsPagination,
  selectCampaignFilters,
  selectCampaignPosts
} from "./campaignSelector";
import {ActionCreateRequestActivityEnum} from "../../services/openapi";
import moment from "moment";
import config from "../../config/config";

const PAGE_SIZE = 20;

function* getCampaignsSaga(action) {
  const { filters, callback = null } = action.payload;
  const page = filters?.page ? filters.page : 0;
  const size = filters?.size ? filters.size : 20;
  try {
    const {data} = yield apiCampaignsService.getUserCampaigns({page, size});
    const {content = []} = data;
    //const data = mockCampaigns;
    const campaigns = transformCampaignList(content);
    yield put(CampaignAction.updateCampaignState({ campaigns }));
    //yield delay(2000);

    if (callback) callback(data);
  } catch (e) {
    if (callback) callback([]);
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* createCampaignSaga(action) {
  const { data, callback } = action.payload;
  try {
    //const reqObject = prepareProxy(data);
    const { response } = yield apiCampaignsService.createCampaign(data);
    yield put(CampaignAction.getCampaigns());
    yield callback(response);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* updateCampaignSaga(action) {
  const { data, callback, id } = action.payload;
  try {
    const { response } = yield apiCampaignsService.updateCampaign(id, data);
    yield put(CampaignAction.getCampaigns());
    yield callback(response);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* deleteCampaignSaga(action) {
  const { id, callback } = action.payload;
  try {
    //yield apiProxyService.deleteProxyServer(data.id);
    //yield callback();
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getCampaignSaga(action) {
  const { callback, id } = action.payload;
  try {
    const { data } = yield apiCampaignsService.getCampaign(id);
    const campaign = transformCampaign(data);

    //const { data: avatarsData = [] } = yield apiAvatarsService.getAvailableAvatars(campaign?.socialNetwork);
    //yield delay(2000);

    //yield put(CampaignAction.updateCampaignState({ campaign, campaignStep: campaign?.stepWithStatsDto?.[0], avatars: avatarsData }));
    yield put(CampaignAction.updateCampaignState({ campaign, campaignStep: campaign?.stepWithStatsDto?.[0] }));

    yield callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getCampaignStatsSaga(action) {
  const { callback, id } = action.payload;
  //const offset = new Date().getTimezoneOffset();

  let zoneId = config?.timezoneId;
  if (zoneId === 'Europe/Kyiv') {
    zoneId = 'Europe/Kiev';
  }



  try {
    const { data } = yield apiCampaignsService.getCampaignStat(id, {zoneId});
    const preparedWeeks = transformCampaignWeeks(data);
    console.log('apiCampaignWeeks', preparedWeeks);

    yield put(CampaignAction.updateCampaignState({ campaignWeeks: preparedWeeks }));

    yield callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getCampaignAvatarsSaga(action) {
  const { callback, id } = action.payload;
  try {
    const { data: avatarsData = [] } = yield apiAvatarsService.getAvailableAvatars('X');
    //yield delay(2000);

    yield put(CampaignAction.updateCampaignState({ avatars: avatarsData }));

    yield callback(avatarsData);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* createCampaignEventSaga(action) {
  const { stepId, eventsData, callback} = action.payload;
  try {
    const { data } = yield apiEventsService.createAction(stepId, eventsData);
    yield put(CampaignAction.getCampaignEvents(stepId, {}, () => {}));

    yield callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* createCampaignEventsSaga(action) {
  const { stepId, eventsArray, callback} = action.payload;
  try {
    const { data } = yield apiEventsService.createActions(stepId, eventsArray);
    yield put(CampaignAction.getCampaignEvents(stepId, {}, () => {}));

    yield callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* updateCampaignEventSaga(action) {
  const { eventId, eventData, callback} = action.payload;
  try {
    const { data } = yield apiEventsService.updateAction(eventId, eventData);
    if (data?.stepId) {
      yield put(CampaignAction.getCampaignEvents(data?.stepId, {}, () => {}));
    }

    yield callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* deleteCampaignEventSaga(action) {
  const { event, callback} = action.payload;
  console.log('deleteCampaignEventSaga', event);
  try {
    const { data } = yield apiEventsService.removeAction(event?.id);
    if (event?.stepId) {
      yield put(CampaignAction.getCampaignEvents(event?.stepId, {}, () => {}));
    }

    yield callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}


function* getCampaignEventsSaga(action) {
  const { stepId, filters = {}, callback} = action.payload;
  const {page = 0, size = PAGE_SIZE} = filters;
  const storedFilters = yield select(selectCampaignFilters);
  const preparedFilters = transformEventFilters(storedFilters);


  try {
    const { data } = yield apiEventsService.getActionsForStep(stepId, {page, size, ...preparedFilters});
    console.log('getCampaignEventsSaga', data, preparedFilters);

    switch (preparedFilters?.activity) {
      case ActionCreateRequestActivityEnum.UserPost:
        const preparedPosts = transformCampaignPosts(data);
        yield put(CampaignAction.updateCampaignState({ filteredEvents: preparedPosts, paginationState: {last: data?.last, page: data?.number} }));

        break;

      case ActionCreateRequestActivityEnum.CommentPost:
        const preparedComments = transformCampaignComments(data);
        yield put(CampaignAction.updateCampaignState({ filteredEvents: preparedComments, paginationState: {last: data?.last, page: data?.number} }));

        break;

      case ActionCreateRequestActivityEnum.LikePost:
        const preparedLikes = transformCampaignLikes(data);
        yield put(CampaignAction.updateCampaignState({ filteredEvents: preparedLikes, paginationState: {last: data?.last, page: data?.number} }));

        break;


      default:
        break;
    }


    yield callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getMoreCampaignEventsSaga(action) {
  const { stepId, filters = {}, callback} = action.payload;
  const { page } = yield select(selectCampaignEventsPagination);
  const currentEvents = yield select(selectCampaignEvents);
  const storedFilters = yield select(selectCampaignFilters);
  const preparedFilters = transformEventFilters(storedFilters);

  const {size = PAGE_SIZE} = filters;

  try {
    const { data } = yield apiEventsService.getActionsForStep(stepId, {page: page + 1, size, ...preparedFilters});
    console.log('getMoreCampaignEventsSaga', data);

    switch (preparedFilters?.activity) {
      case ActionCreateRequestActivityEnum.UserPost:
        const preparedPosts = transformCampaignPosts(data);
        yield put(CampaignAction.updateCampaignState({ filteredEvents: [...currentEvents, ...preparedPosts], paginationState: {last: data?.last, page: data?.number} }));

        break;

        case ActionCreateRequestActivityEnum.CommentPost:
        const preparedComments = transformCampaignComments(data);
        yield put(CampaignAction.updateCampaignState({ filteredEvents: [...currentEvents, ...preparedComments], paginationState: {last: data?.last, page: data?.number} }));

        break;

      case ActionCreateRequestActivityEnum.LikePost:
        const preparedLikes = transformCampaignLikes(data);
        yield put(CampaignAction.updateCampaignState({ filteredEvents: [...currentEvents, ...preparedLikes], paginationState: {last: data?.last, page: data?.number} }));

        break;


      default:
        break;
    }



    yield callback(data);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}


function* getCampaignPostSaga(action) {
  const { postId, callback = () => {}} = action.payload;

  try {
    const { data } = yield apiEventsService.getAction(postId, { displayAllChildAction: true});
    const {childAction = []} = data;
    const preparedChildren = transformPostChildren(childAction);
    console.log('getCampaignPost', preparedChildren);

    yield callback({...data, childAction: preparedChildren});
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}


function* getAIEventContentSaga(action) {
  const { stepId, generationRequest, callback = () => {}} = action.payload;


  try {
    const { data } = yield apiEventsService.generateActions(stepId, generationRequest);
    console.log('getAICampaignPost', data);

    yield callback(data?.actions?.content);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

function* getCampaignDaylyEventsSaga(action) {
  const { stepId, filters = {}, callback} = action.payload;
  const {page = 0, size = PAGE_SIZE} = filters;

  try {
    const { data } = yield apiEventsService.getActionsForStep(stepId, {page, size, ...filters});
    let preparedEvents = [];

    switch (filters?.activity) {
      case ActionCreateRequestActivityEnum.UserPost:
        preparedEvents = transformCampaignPosts(data);
        break;

      case ActionCreateRequestActivityEnum.CommentPost:
        preparedEvents = transformCampaignComments(data);
        break;

      case ActionCreateRequestActivityEnum.LikePost:
        preparedEvents = transformCampaignLikes(data);
        break;


      default:
        break;
    }

    yield callback(preparedEvents);
  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}


export function* watchCampaign() {
  yield takeEvery(CampaignAction.GET_CAMPAIGNS, getCampaignsSaga);
  yield takeEvery(CampaignAction.CREATE_CAMPAIGN, createCampaignSaga);
  yield takeEvery(CampaignAction.DELETE_CAMPAIGN, deleteCampaignSaga);
  yield takeEvery(CampaignAction.UPDATE_CAMPAIGN, updateCampaignSaga);
  yield takeEvery(CampaignAction.GET_CAMPAIGN, getCampaignSaga);
  yield takeEvery(CampaignAction.GET_CAMPAIGN_STATS, getCampaignStatsSaga);
  yield takeEvery(CampaignAction.GET_CAMPAIGN_AVATARS, getCampaignAvatarsSaga);
  yield takeEvery(CampaignAction.CREATE_CAMPAIGN_EVENT, createCampaignEventSaga);
  yield takeEvery(CampaignAction.CREATE_CAMPAIGN_EVENTS, createCampaignEventsSaga);
  yield takeEvery(CampaignAction.UPDATE_CAMPAIGN_EVENT, updateCampaignEventSaga);
  yield takeEvery(CampaignAction.DELETE_CAMPAIGN_EVENT, deleteCampaignEventSaga);
  yield takeEvery(CampaignAction.GET_CAMPAIGN_EVENTS, getCampaignEventsSaga);
  yield takeEvery(CampaignAction.GET_CAMPAIGN_POST, getCampaignPostSaga);
  yield takeEvery(CampaignAction.GET_AI_EVENT_CONTENT, getAIEventContentSaga);
  yield takeEvery(CampaignAction.GET_MORE_CAMPAIGN_EVENTS, getMoreCampaignEventsSaga);
  yield takeEvery(CampaignAction.GET_CAMPAIGN_DAILY_EVENTS, getCampaignDaylyEventsSaga);
}
